import React from 'react';
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import ReactDOM from 'react-dom';

// Function to format the file name
const formatFileName = (nameOfEmployee, date) => {
  const formattedDate = new Date().toLocaleDateString().replace(/\//g, '-');
  return `Arrears_Seventh_${nameOfEmployee}_${formattedDate}.pdf`;
};

// Styles for the PDF document
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 10,
  },
  header: {
    marginTop: 8,
    marginBottom: 1,
    borderBottom: 2,
    marginLeft: 20, // Add left margin
    marginRight: 20, // Add right margin
    borderBottomColor: '#000000',
    paddingBottom: 1,
    textAlign: 'center',
  },
  Office: {
    fontSize: 14,
    fontStyle: 'Bold',
  },
  Info: {
    flexDirection: 'row', // Aligns children in a row
    justifyContent: 'space-between', // Creates space between left and right sections
    alignItems: 'center', // Aligns items vertically in the center
  },
  specialNote: {
    flexDirection: 'row', // Keeps label and text in a row
    justifyContent: 'flex-end', // Ensures right alignment within the section
    textAlign: 'right', // Aligns text to the right
  },
  specialNoteLabel: {
    fontWeight: 'bold', // Makes the label bold
    marginRight: 4, // Adds space between label and text
    fontSize: 6, // Keeps text size consistent

  },
  specialNoteText: {
    fontSize: 6, // Keeps text size consistent
  },
  
  
  
  employeeInfo: {
    flexDirection: 'row',
    marginBottom: 1,
    flexWrap: 'wrap',
    fontSize: 8,
    marginTop: 3,
    gap: 15,
  },
  nameOfEmployee: {},
  periodInfo: {
    backgroundColor: '#f7fafc',
    padding: 5,
    marginBottom: 1,
    fontSize: 8,
  },
  Designation: {},
  payLevel: {
    fontSize: 8,
    flexDirection: 'row',
    gap: 200,
  },
  /////////////////////////////////////////////////////////////////////////
  table: {
    display: 'table',
    width: '95%',
    marginBottom: 20,
    fontSize: 8,
    alignSelf: 'center',
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1,

  },
  tableHeader: {
    backgroundColor: '#bcbcbc',
    color: '#000000',
    justifyContent: 'flex',
    borderBottomWidth: 2,
    borderBottomColor: '#000000',
  },
  tableSubHeader: {
    backgroundColor: '#f7fafc',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#000000',
  },
  tableCell: {
    padding: 1,
    paddingVertical: 2,
    fontSize: 6,
    textAlign: 'center',  // Ensures content is centered
    flex: 1,
    minWidth: 1,
    wordWrap: 'break-word',
    borderRightWidth: 1,  // Right border for cells
    borderRightColor: '#000000',
  },
  tableCellHeader: {
    fontWeight: 'bold',
    fontSize: 6,
    color: '#000000',
    textAlign: 'center',
  },
  tableCellSubHeader: {
    fontWeight: 'bold',
    fontSize: 6,
    color: '#000000',
    wordWrap: 'break-word',
  
  },
  sectionHeader: {
    backgroundColor: '#000000',
    padding: 1,
  },
  sectionHeaderText: {
    color: '#ffffff',
    fontSize: 10,
    fontWeight: 'bold',
    textAlign: 'center',
  },
///OVERRIDES
  tableCellCustomWidth: {
    width: 30, // Adjust the width as needed (in points)
    padding: 1,
    fontSize: 6,
    textAlign: 'center',
    borderRightWidth: 1,
    borderRightColor: '#000000',
  },
 // Specific column width override (for Sr.No. column)
 tableCellSrNo: {
  width: 20, // Adjust width for Sr.No. (in points)
  padding: 1,
  fontSize: 6,
  textAlign: 'center',
  borderRightWidth: 1,
  borderRightColor: '#000000',
},
  
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    flexDirection: 'row',
    justifyContent: 'space-between',
    borderTopWidth: 1,
    borderTopColor: '#000000',
    paddingTop: 10,
  },
  pageNumber: {
    fontSize: 6,
    color: '#000000',
  },
  dateText: {
    fontSize: 6,
    color: '#000000',
  },
  Himanshu: {
    textAlign: 'center',
    fontSize: 6,
  },
  button: {
    backgroundColor: '#32afca',
    color: '#ffffff',
    padding: '10px 20px',
    fontSize: '14px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  buttonHover: {
    backgroundColor: '#007b8e',
  },
  buttonContainer: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    marginTop: '20px',
  },
});

// Your main PDF component
const ArrearsSeventhPurePDF = ({ result, info }) => {
  const itemsPerPage = 30;

  // Define main headers, each with a title and span (the number of columns it occupies)
  const mainHeaders = [
    { title: '', span: 2 },
    { title: 'DUE SALARY', span: 8 },
    { title: 'DRAWN SALARY', span: 8 },
    { title: 'DIFFERENCE', span: 7 },
    { title: 'PROF. TAX', span: 3 },
    { title: '', span: 1 },
  ];

  const columnHeaders = [
    'Sr.No.', 'Month', 'Basic Pay', '%DA', 'DA', 'CLA', 'HRA', 'TRA', 'Spl', 'Total',
    'Basic Pay', '%DA', 'DA', 'CLA', 'HRA', 'TRA', 'Spl', 'Total',
    'Basic Pay', 'DA', 'CLA', 'HRA', 'TRA', 'Spl', 'Total',
    'PTDue', 'PTDrawn', 'PTRec', 'Net'
  ];

return(
    <Document>
      {Array.from({ length: Math.ceil(result.length / itemsPerPage) }).map((_, pageIndex) => (
        <Page key={pageIndex} size="A4" orientation="landscape" style={styles.page}>
          {/* Header Section */}
          <View style={styles.header}>
            <View style={styles.Office}>
              <Text style={styles.value}>{info.officeName}</Text>
            </View>
            <View style={styles.periodInfo}>
              <Text style={styles.periodText}>
                Statement showing the difference of Pay & Allowances payable/recovery due to revision of pay for the period: {info.arrearsStartDate} to {info.arrearsEndDate}
              </Text>
            </View>
        <View style={styles.Info}>
          <View>
            <View style={styles.employeeInfo}>
              <View style={styles.nameOfEmployee}>
                <Text style={styles.label}>Employee Name: {info.employeeName}</Text>
              </View>
              <View style={styles.Designation}>
                <Text style={styles.label}>Designation: {info.designation}</Text>
              </View>
            </View>
            <View style={styles.payLevel}>
              <View>
                <Text style={styles.label}>Due Pay Level/s: {info.duePayLevel}</Text>
              </View>
              <View style={styles.drawnPayLevel}>
                <Text style={styles.label}>Drawn Pay Level/s: {info.drawnPayLevel}</Text>
              </View>
            </View>
          </View>
             {/* Special Note Section */}
          <View style={styles.specialNote}>
          <Text style={styles.specialNoteLabel}>Special Note:</Text>
<Text style={styles.specialNoteText}>{info.specialNote || '--'}</Text>

          </View>
        </View> 
          </View>

          {/* Table Section */}
          <View style={styles.table}>
            {/* Main Headers */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            {mainHeaders.map((header, index) => (
              <View
                key={index}
                style={[styles.tableCell,{ flex: header.span }]}  // First column width is set to 100
              >
                <Text style={styles.tableCellHeader}>{header.title}</Text>
              </View>
            ))}
          </View>

            {/* Column Headers */}
            <View style={[styles.tableRow, styles.tableSubHeader]}>
              {columnHeaders.map((header, index) => (
                <View key={index} style={[index === 0 || index === 3 || index === 11 ? styles.tableCellSrNo :index === 1 ? styles.tableCellCustomWidth :styles.tableCell]}>
                  <Text style={styles.tableCellSubHeader}>{header}</Text>
                </View>
              ))}
            </View>

        {/* Subheader Row with 1 to 29 */}
              <View style={[styles.tableRow, styles.tableSubHeader]}>
                {Array.from({ length: 29 }).map((_, index) => (
                  <View key={index} style={[index === 0 || index === 3 || index === 11 ? styles.tableCellSrNo :index === 1 ? styles.tableCellCustomWidth :styles.tableCell]}>
                    <Text>{index + 1}</Text>
                  </View>
                ))}
              </View>

              {/* Table Body */}
              {result
                .slice(pageIndex * itemsPerPage, (pageIndex + 1) * itemsPerPage)
                .map((row, rowIndex) => (
                  <View key={rowIndex} style={styles.tableRow}>
                    {/* First Column for Row Numbers */}
                    <View style={styles.tableCellSrNo}>
                      <Text>{pageIndex * itemsPerPage + rowIndex + 1}</Text>
                    </View>
                    {/* Data Columns */}
                    {row.map((cell, cellIndex) => (
                      <View key={cellIndex} style={[cellIndex === 2 || cellIndex === 10 ? styles.tableCellSrNo :cellIndex === 0 ? styles.tableCellCustomWidth :styles.tableCell]}>
                        <Text>{cell}</Text>
                      </View>
                    ))}
                  </View>

                      ))}
          
            </View>

          {/* Footer Section */}
          <View style={styles.footer}>
          <Text style={styles.dateText}>
  Generated on: {`${String(new Date().getDate()).padStart(2, '0')}/${String(new Date().getMonth() + 1).padStart(2, '0')}/${new Date().getFullYear()}`}
          </Text>

            <Text style={styles.Himanshu}>Himanshu Salary Corner</Text>
            <Text style={styles.pageNumber}>
              Page {pageIndex + 1} of {Math.ceil(result.length / itemsPerPage)}
            </Text>
          </View>
        </Page>
      ))}
    </Document>
  );
};

export default ArrearsSeventhPurePDF;
